// extracted by mini-css-extract-plugin
export var caption = "styles-module--caption--6b2d3";
export var h1 = "styles-module--h1--fb6d4";
export var h2 = "styles-module--h2--ecd8c";
export var h3 = "styles-module--h3--b6fb3";
export var h4 = "styles-module--h4--45dea";
export var h5 = "styles-module--h5--9a622";
export var nav_title = "styles-module--nav_title--93b56";
export var paragraph = "styles-module--paragraph--26b81";
export var subtitle_primary = "styles-module--subtitle_primary--50ff5";
export var subtitle_secondary = "styles-module--subtitle_secondary--1c67e";